module.exports = __webpack_public_path__ + "assets/nextjs.a0054c0a.svg";